import './mfeUrls'
// Dynamic import creates an async boundary so MF2 can initialize shared modules
// before loader.ts runs — static import breaks contrastBase/state resolution.
// @ts-ignore
void import('./loader')
